import api from './index';

const BASE = '/completed-calculation';

export const getCompletedCalculations = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
}: {
    dateFrom: string;
    dateTo: string;
    workingUnitLocation: number;
}) => {
    return api.get(BASE, { params: { dateFrom, dateTo, workingUnitLocation } }).then((res) => res.data);
};

export const completeCalculation = async ({
    dateFrom,
    dateTo,
    locations,
    workingUnits,
}: {
    dateFrom: string;
    dateTo: string;
    locations: number[];
    workingUnits: number[];
}) => {
    return api.post(BASE, { dateFrom, dateTo, locations, workingUnits }).then((res) => res.data);
};
